const search_results = (state) => state.search_results;

export default {
  search_results,
};
